import React, { Component } from 'react';
import DayColumnSmall from './DayColumnSmall';
import DayHeadingSmall from './DayHeadingSmall';
import type { CalendarContentProps, CalendarDate } from '../../../types';

type State = {
  activeTab: string,
}

class CalendarContentSmall extends Component<CalendarContentProps, State> {
  state: State = {
    activeTab: 'Mon',
  };

  componentDidMount = () => {
    const { dates } = this.props;
    const { activeTab } = this.state;
    const today: CalendarDate | undefined = dates.find((date: CalendarDate) => date.isToday);
    if (today && today.dayName !== activeTab) {
      this.setState({
        activeTab: today.dayName,
      });
    }
  };

  handleChangeTab = (dayName: string) => {
    this.setState({
      activeTab: dayName,
    });
  };

  render() {
    const {
      dates,
      logsById,
      onOpenAddModal,
      onOpenEditModal,
      projects,
      getLogIdsForWeekday,
      holidays,
      selectedUserVacationDates,
      workSessions,
      deskLabelsByDate,
    } = this.props;
    const { activeTab } = this.state;
    const dayNamesByDate: { [k: string]: string } = {};
    dates.forEach((date: CalendarDate) => {
      dayNamesByDate[date.date] = date.dayName;
    });

    return (
      <div className="device-small">
        <div className="row nav-tab-container text-container text-center no-gutters">
          <ul className="nav nav-tabs hidden-md-up text-center" role="tablist">
            {dates.map((date: CalendarDate) => (
              <DayHeadingSmall
                day={date.day}
                month={date.month}
                dayName={date.dayName}
                date={date.date}
                isToday={date.isToday}
                key={date.dayName}
                onTabLinkClick={this.handleChangeTab}
                activeTab={activeTab}
                workSessions={workSessions}
                deskLabel={deskLabelsByDate[date.date]}
              />
            ))}
          </ul>
        </div>
        <div className="calendar-main-content">
          <div className="tab-content row">
            {dates.map((day: CalendarDate) => (
              <DayColumnSmall
                onOpenEditModal={onOpenEditModal}
                onOpenAddModal={onOpenAddModal}
                dayNamesByDate={dayNamesByDate}
                projects={projects}
                logsById={logsById as { [k: string]: any }}
                logIds={getLogIdsForWeekday(day.date) as Array<string | number>}
                day={day}
                key={day.date}
                showTab={day.dayName === activeTab}
                holidays={holidays}
                selectedUserVacationDates={selectedUserVacationDates}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default CalendarContentSmall;
